export const HOME_ACTIVE = require('./home/home.png');
export const HOME_INACTIVE = require('./home/InactiveHome.png');

export const TRACK_ACTIVE = require('./track/ActiveTrack.png');
export const TRACK_INACTIVE = require('./track/InactiveTrack.png');

export const EARNING_INACTIVE = require('./Earning/InactiveEarning.png');
export const EARNING_ACTIVE = require('./Earning/ActiveEarning.png');

export const PROFILE_ACTIVE = require('./Profile/ActiveProfile.png');
export const PROFILE_INACTIVE = require('./Profile/InactiveProfile.png');

export const BACK_ARROW = require('./back_arrow.png');
